import {REQUEST_TYPE} from '../../../constants';
import {doRequest} from '../../../helpers/network';
import {Revenue} from '../../../helpers/Urls';

const INITIAL_STATE = {
  searching: false,
  testRuleData: {},
  error: '',
};

const FETCH_TEST_RULE = 'FETCH_TEST_RULE';
const FETCH_TEST_RULE_COMPLETED = 'FETCH_TEST_RULE_COMPLETED';
const FETCH_TEST_RULE_FAILED = 'FETCH_TEST_RULE_FAILED';

export const fetchTestRule = (searchText) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_TEST_RULE});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Revenue.fetchTestRuleDataURL(searchText),
      });

      const {data, status} = response || {};
      if (status === true) {
        dispatch({type: FETCH_TEST_RULE_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({type: FETCH_TEST_RULE_FAILED, payload: {error: message}});
      }
    } catch (err) {
      dispatch({type: FETCH_TEST_RULE_FAILED, payload: {error: err.message}});
    }
    return response;
  };
};

export const resetTestRuleData = () => {
  return (dispatch) => {
    dispatch({type: 'RESET_TEST_RULE'});
  };
};

export default (state = INITIAL_STATE, action) => {
  const {type, payload} = action || {};
  switch (type) {
    case FETCH_TEST_RULE:
      return {...state, searching: true, error: ''};
    case FETCH_TEST_RULE_COMPLETED:
      return {...state, searching: false, testRuleData: payload};
    case FETCH_TEST_RULE_FAILED:
      return {...state, searching: false, error: payload.error};
    case 'RESET_TEST_RULE':
      return {...state, testRuleData: {}};
    default:
      return {...state};
  }
};
